import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap";
import API from "../../helpers/endpointservice";
import axios from "axios";
import $ from "jquery";
import CommonIcon from "../../helpers/icons";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import Select from "react-select";
import LoaderVisible from "../../helpers/loader";
import LoaderFailed from "../../helpers/loaderFailed";
import Pagination from 'react-js-pagination';
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";
import moment from "moment";
import CommonCloneModal from "../common/commonCloneModal";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  })
}

class MainRoles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pagingListMainRole: [{ "label": "20", "value": 20 }],
      paginListNewPage: [{ "label": "20", "value": 20 }],
      paginglist: [{ "label": "5", "value": 5 }, { "label": "10", "value": 10 }, { "label": "20", "value": 20 }, { "label": "50", "value": 50 }],
      paginglistDefault: [{ "label": "20", "value": 20 }],
      order: "asc",
      order1: "asc",
      sortBy: "name",
      sortBy1: "jobGroup",
      currentUser: "",
      isRequestFailed: false,
      isRequestLoader: false,
      // pageNewCount: false,
      userId: 0,
      height: window.innerHeight,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      isMainRole: true,
      isNewTemplate: false,
      isEditTemplate: false,
      pageCountMr: 20,
      currentPageMr: 1,
      perPageMr: 20,
      pageCount: 20,
      selectedItem: [],
      currentPage: 1,
      perPage: 20,
      totalCount: 0,
      requestCount: 0,
      mainRolesList: [],
      putNewData: {},
      roleData: {},
      isSearchRole: false,
      job: "",
      level: "",
      skill: "",
      proficiencyExpected: "",
      roleId: 0,
      skillsList: [],
      levelList: [],
      proficiencyList: [],
      jobList: [],
      proficiencyExpectedValue: "",
      proficiencyId: 0,
      skillNameValue: "",
      skillId: 0,
      LevelNameValue: "",
      LevelId: 0,
      JobNameValue: "",
      JobGroupValue: "",
      jobId: 0,
      roleName: "",
      removeData: "",
      jobData: [],
      isAdd: false,
      isEdit: false,
      pageNumber: 1,
      isFieldEmpty: false,
      isSkillEmpty: false,
      isJobEmpty: false,
      isJobGroupEmpty: false,
      isProficiencyEmpty: false,
      isLevelEmpty: false,
      jobNameEditShow: "",
      skillNameEditShow: "",
      levelNameEditShow: "",
      proficiencyNameEditShow: "",
      isSearch: false,
      searchData: {},
      skillSearch: [],
      jobSearch: "",
      jobGroupSearch: "",
      levelSearch: [],
      proficiencySearch: [],
      isAddHide: false,
      searchInput: "",
      auditLog: [],
      isView: false,
      mainRoleId: NaN,
      cloneId: 0,
      cloneIds: [],
      jobGroupLimitExceed: false,
      jobLimitExceed: false,
      mappingList: [],
      mapping: false,
    };
  }

  componentDidMount() {
    this.state.isRequestLoader = true;
    this.getMainroleList();
    this.getSkillsList();
    this.getLevelList();
    this.getProficiencyList();
    let user = localStorage.getItem("UserId");
    let Rolevalue = localStorage.getItem("Role").split(",")[0];
    this.state.userId = parseInt(user);
    this.state.currentUser = Rolevalue;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    $("body").removeClass("scrollhide");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 750) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 490) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 450) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = false;
    }

    this.state.height = window.innerHeight;
    this.setState({});
  };

  getProficiencyList = () => {
    let apiUrl = `${API.GET_PROFICIENCY}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.proficiencyList = res?.data?.map((proficiency) => {
            return {
              value: proficiency.id + "," + proficiency.name,
              label: (
                <>
                  {/* <CommonIcon
                      className="properties-img-2"
                      fileName="proficiencyExpected"
                    />{" "}
                    &nbsp; */}
                  <span>{proficiency.name}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getMainroleList = () => {
    let apiUrl = `${API.GET_MAIN_ROLES}?sortBy=${this.state.sortBy
      }&isSortAscending=${this.state.order == "asc" ? true : false}&pageNumber=${this.state.currentPageMr
      }&pageSize=${this.state.perPageMr}`;
    axios({
      method: "POST",
      url: apiUrl,
      // data: this.state.isSearchRole ? { name : this.state.searchInput } : {}
      data: { name: this.state.searchInput }
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.mainRolesList = res.data.values;
          this.state.pageCountMr = res.data.totalCount;
          this.state.isRequestFailed = false;
          this.state.isSearchRole = false;
          this.setState({ isRequestLoader: false });
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getMainroleById = (name) => {
    // this.state.mainRolesList = [];
    let apiUrl = `${API.GET_MAIN_ROLE}?id=${this.state.roleId}&sortBy=${this.state.sortBy1
      }&isSortAscending=${this.state.order1 == "asc" ? true : false}&pageNumber=${this.state.currentPage
      }&pageSize=${this.state.perPage}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: this.state.searchData,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.pageCount = res.data.totalCount;
          if (res.data.values.length > 0) {
            this.state.mainRolesList = res.data.values;
          } else if (name == "search") {
            this.state.mainRolesList = [];
          } else {
            this.state.isNewTemplate = true;
            this.state.isEditTemplate = false;
            this.state.mainRolesList = [];
          }
          // this.state.removeData = res.data.skillJobs;
          // this.state.pageCount = res.data.totalCount;
          // this.state.isRequestFailed = false;
          // if(this.state.order == "asc"){
          //   this.setState({ order : "desc" })
          // }else{
          //   this.setState({ order : "asc" })
          // }
          this.state.isRequestLoader = false;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isRequestLoader: false, isRequestFailed: true });
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  putMainRole = () => {
    let apiUrl = `${API.PUT_MAIN_ROLE}?userId=${this.state.userId}`;
    axios({
      method: "PUT",
      url: apiUrl,
      data: this.state.putNewData,
    })
      .then((res) => {
        if (res.status === 200) {
          if (this.state.isEdit) {
            toast.success("Main roles edited successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          } else if (this.state.isAdd) {
            this.clearSearchFields();
            toast.success("Main roles added successfully", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
          }
          this.state.isRequestLoader = false;
          // this.state.currentPage = 1;
          this.state.selectedItem = [];
          this.state.isNewTemplate = false;
          this.state.isEditTemplate = true;
          this.state.isFieldEmpty = false;
          this.state.isAdd = false;
          this.state.isEdit = false;
          this.getMainroleById(this.state.roleId);
          this.closeProperties();
          this.setState({});
          $("body").removeClass("scrollhide");
          // this.getMainroleList();
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isRequestLoader: false });
        // if (this.state.isEdit) {
        //   toast.error("Failed to edit Main roles", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // } else if (this.state.isAdd) {
        //   toast.error("Failed to add Main roles ", {
        //     position: toast.POSITION.TOP_RIGHT,
        //     color: "#fff",
        //   });
        // }
        swal("Error!", "Something went wrong. Please try again.", "warning");
        console.log(error);
      });
  };

  getMainroleJobById = (id) => {
    // this.state.mainRolesList = [];
    let apiUrl = `${API.GET_MAIN_JOB_BYID}?id=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          let auditLogTemp = res.data.historyLog;
          this.state.jobData = res.data;
          // this.state.jobId = res.data.jobId;
          this.state.LevelId = res.data.levelId;
          this.state.skillId = res.data.skillId;
          this.state.proficiencyId = res.data.proficiencyExpectedId;
          this.state.skillNameValue = res.data?.skill ? res.data.skill : "";
          this.state.LevelNameValue = res.data?.level ? res.data.level : "";
          this.state.proficiencyExpectedValue = res.data?.proficiencyExpected ? res.data.proficiencyExpected : "";
          this.state.JobNameValue = res.data?.jobName ? res.data.jobName : "";
          this.state.auditLog = auditLogTemp;
          this.state.JobGroupValue = res.data?.jobGroup ? res.data.jobGroup : "";
          this.state.skillNameEditShow = (res.data.skillId) ? (this.state.skillsList?.filter(
            (c) => parseInt(c.value?.split(",")[0]) === res.data?.skillId
          )[0]) : [];
          this.state.levelNameEditShow = (res.data.levelId) > 0 ? (this.state.levelList?.filter(
            (c) => parseInt(c.value?.split(",")[0]) === res.data?.levelId
          )[0]) : [];
          this.state.proficiencyNameEditShow = (res.data.proficiencyExpectedId > 0) ?
            (this.state.proficiencyList?.filter(
              (c) =>
                parseInt(c.value?.split(",")[0]) ===
                res.data?.proficiencyExpectedId
            )[0]) : [];
          this.state.isRequestFailed = false;
          this.setState({ isRequestLoader: false });
          let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("addMainRoleScreen")
          );
          myOffcanvas.show();
          $("body").addClass("scrollhide");
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isRequestLoader: false });
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  deleteMainRole = () => {
    this.state.isRequestLoader = true;
    let apiUrl = `${API.DELETE_MAIN_ROLE_BYID}?userId=${this.state.roleId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: this.state.selectedItem,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Main roles deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          // this.state.currentPage = 1;
          this.state.selectedItem = [];
          this.getMainroleById();
          this.setState({});
          $("body").removeClass("scrollhide");
          // this.getMainroleList();
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });

  };

  fetchPaginationList = (pageNumber, pageSize) => {
    this.state.isRequestLoader = true;
    this.state.perPage = pageSize;
    this.state.currentPage = pageNumber;
    this.setState({});
    if (this.state.isMainRole) {
      this.setState({ cloneIds: [], cloneId: 0 }, () => {
        this.getMainroleList();
      });
    } else if (this.state.isEditTemplate) {
      this.getMainroleById();
    }
  };

  handlecategoryInputchange(e, field, type) {
    if (type === "Add") {
      this.state.addcategoryValue[field] = e.target.value;
      this.state.categoryEmpty = false;
      this.setState({});
    } else if (type === "Edit") {
      this.state.editcategoryValue[field] = e.target.value;
      this.setState({});
    }
  }

  openAddMainRole = () => {
    this.state.selectedItem = [];
    this.state.mainRoleId = NaN;
    this.state.isSearch = false;
    this.state.isAdd = true;
    this.state.isEdit = false;
    this.state.isFieldEmpty = false;
    this.state.isView = false;
    this.state.jobGroupLimitExceed = false;
    this.state.jobLimitExceed = false;
    this.setState({});
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addMainRoleScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  openMainroleEdit = (isView, id) => {
    this.state.isRequestLoader = true;
    this.state.isSearch = false;
    this.state.isAdd = false;
    this.state.isEdit = true;
    this.state.isFieldEmpty = false;
    this.state.isView = isView;
    this.state.jobGroupLimitExceed = false;
    this.state.jobLimitExceed = false;
    this.state.mainRoleId = id || this.state.selectedItem[0];
    this.setState({});
    // let myOffcanvas = new window.bootstrap.Offcanvas(
    //   document.getElementById("addMainRoleScreen")
    // );
    // myOffcanvas.show();
    // $("body").addClass("scrollhide");
    this.getMainroleJobById(id || this.state.selectedItem[0]);
  };

  openRemoveScreen = () => {
    let myOffcanvas = new window.bootstrap.Modal(
      document.getElementById("CancelCourseScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  }
  openRemoveScreenMain = () => {
    let myOffcanvas = new window.bootstrap.Modal(
      document.getElementById("deleteMainRoleWarning")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  }

  closeProperties = () => {
    this.state.selectedItem = [];
    this.setState({
      jobNameEditShow: "",
      skillNameEditShow: [],
      levelNameEditShow: [],
      proficiencyNameEditShow: [],
      JobGroupValue: "",
      JobNameValue: "",
      JobGroupName: "",
      jobGroupSearch: "",
      skillNameValue: "",
      proficiencyExpectedValue: "",
      LevelNameValue: "",
      LevelId: null,
      jobId: null,
      proficiencyId: null,
      skillId: null,
      isJobEmpty: false,
      isJobGroupEmpty: false,
      isLevelEmpty: false,
      isProficiencyEmpty: false,
      isSkillEmpty: false,
      isSearch: false,
      isAdd: false,
      isEdit: false,
      jobData: [],
      searchData: {},
      auditLog: []
    });
  };

  chooseTemplates = (template, roleid, rolename) => {
    this.state.roleId = roleid;
    this.state.roleName = rolename;
    this.state.mainRolesList = [];
    this.state.isMainRole = false;

    if (template == false) {
      this.state.selectedItem = [];
      this.state.isNewTemplate = true;
      this.state.isEditTemplate = false;
      this.setState({});
    } else if (template == true) {
      this.state.isRequestLoader = true;
      this.state.isNewTemplate = false;
      this.state.isEditTemplate = true;
      // this.state.sortBy1 = "jobName";
      // this.state.order = "asc";
      $("body").removeClass("scrollhide");
      this.setState({});
      this.getMainroleById();
    }
  };

  searchMainRoleList = () => {
    if (
      this.state.jobGroupSearch?.trim() !== "" ||
      this.state.jobSearch?.trim() !== "" ||
      this.state.skillSearch?.value?.split(",")[1]?.trim().length > 0 ||
      this.state.levelSearch?.value?.split(",")[1]?.trim().length > 0 ||
      this.state.proficiencySearch?.value?.split(",")[1]?.trim().length > 0
    ) {
      this.state.searchData = {
        jobGroup: this.state.jobGroupSearch || null,
        job: this.state.jobSearch || null,
        skillId: this.state.skillSearch?.value?.split(",")[0] || 0,
        skill: this.state.skillSearch?.value?.split(",")[1] || null,
        levelId: this.state.levelSearch?.value?.split(",")[0] || 0,
        level: this.state.levelSearch?.value?.split(",")[1] || null,
        proficiencyExpectedId: this.state?.proficiencySearch?.value?.split(",")[0] || 0,
        proficiencyExpected: this.state?.proficiencySearch?.value?.split(",")[1] || null,
      };
      this.state.isRequestLoader = true;
      this.state.currentPage = 1;
      this.state.isSearch = false;
      this.state.isFieldEmpty = false;
      this.setState({
        pageNewCount: !this.state.pageNewCount
      });
      // $("#addMainRoleScreen").removeClass("show");
      document.getElementById("closeButton").click();
      $("body").removeClass("scrollhide");
      this.getMainroleById("search");
    } else {
      this.state.isFieldEmpty = true;
    }
  };

  submitNewTemplate = () => {
    this.state.putNewData = {
      roleId: this.state.roleId,
      name: this.state.roleName,
      isPresent: this.state.mainRoleId ? true : false,
      skillJobs: [
        {
          id: this.state.mainRoleId || 0, //this.state.selectedItem[0] || 0,
          jobGroup: this.state.JobGroupValue?.trim(),
          jobName: this.state.JobNameValue?.trim(),
          skillId: this.state.skillId,
          skill: this.state.skillNameValue,
          levelId: this.state.LevelId,
          level: this.state.LevelNameValue,
          proficiencyExpectedId: this.state.proficiencyId,
          proficiencyExpected: this.state.proficiencyExpectedValue,
        },
      ],
    };
    if (
      this.state.JobGroupValue?.trim() == "" ||
      this.state.JobNameValue?.trim() == "" ||
      this.state.skillNameValue?.trim() == "" ||
      this.state.LevelNameValue?.trim() == "" ||
      this.state.proficiencyExpectedValue?.trim() == ""
    ) {
      // this.setState({isFieldEmpty : true})
      if (this.state.JobGroupValue?.trim() == "") {
        this.state.isJobGroupEmpty = true;
      } else {
        this.state.isJobGroupEmpty = false;
      }
      if (this.state.JobNameValue?.trim() == "") {
        this.state.isJobEmpty = true;
      } else {
        this.state.isJobEmpty = false;
      }
      if (this.state.JobGroupName?.trim() == "") {
        this.state.isJobGroupEmpty = true;
      } else {
        this.state.isJobGroupEmpty = false;
      }
      if (this.state.skillNameValue?.trim() == "") {
        this.state.isSkillEmpty = true;
      } else {
        this.state.isSkillEmpty = false;
      }
      if (this.state.LevelNameValue?.trim() == "") {
        this.state.isLevelEmpty = true;
      } else {
        this.state.isLevelEmpty = false;
      }
      if (this.state.proficiencyExpectedValue?.trim() == "") {
        this.state.isProficiencyEmpty = true;
      } else {
        this.state.isProficiencyEmpty = false;
      }
      this.state.isAddHide = false;
      this.setState({});
    } else {
      this.state.isRequestLoader = true;
      document.getElementById("closeButton").click();
      // $("#addMainRoleScreen").removeClass("show");
      $("body").removeClass("scrollhide");
      this.setState({
        skillNameEditShow: [],
        levelNameEditShow: ""
      }, () => {
        this.putMainRole();
      })
    }
  };

  onchangeProficiecy = (e) => {
    if (this.state.isSearch == true) {
      this.setState({ proficiencySearch: e })
    }
    else {
      this.state.proficiencyId = e ? parseInt(e.value.split(",")[0]) : 0;
      this.state.proficiencyExpectedValue = e ? e.value.split(",")[1] : "";
      this.state.proficiencyNameEditShow = e;
      this.setState({});
    }

  };

  onchangeJob = (e) => {
    if (this.state.isSearch == true) {
      this.setState({ jobSearch: e.target.value })
    }
    else {
      if (e.target.value.length > 0) {
        if (e.target.value.trim().length > 250) {
          this.state.jobLimitExceed = true;
          this.setState({});
        } else {
          this.state.jobLimitExceed = false;
          this.state.JobNameValue = e.target.value;
          this.setState({});
        }
      }
      else {
        this.state.JobNameValue = e.target.value;
        this.setState({});
      }
      // // this.state.jobId = parseInt(e.value.split(",")[0]);
      // this.state.JobNameValue = e.target.value;
      // // this.state.jobNameEditShow = e;
      // this.setState({});
    }
  };

  onchangeJobGroup = (e) => {
    if (this.state.isSearch == true) {
      this.setState({ jobGroupSearch: e.target.value })
    }
    else {
      if (e.target.value.length > 0) {
        if (e.target.value.trim().length > 250) {
          this.state.jobGroupLimitExceed = true;
          this.setState({});
        } else {
          this.state.jobGroupLimitExceed = false;
          this.state.JobGroupValue = e.target.value;
          this.setState({});
        }
      }
      else {
        this.state.JobGroupValue = e.target.value;
        this.setState({});
      }
    }
  };

  onchangeLevel = (e) => {
    if (this.state.isSearch == true) {
      this.setState({ levelSearch: e }, () => {

      })
    } else {
      this.state.LevelId = e ? parseInt(e.value.split(",")[0]) : 0;
      this.state.LevelNameValue = e ? e.value.split(",")[1] : "";
      this.state.levelNameEditShow = e;
      this.setState({});
    }
  };

  onchangeSkill = (e) => {
    if (this.state.isSearch == true) {
      this.setState({ skillSearch: e })
    } else {
      this.state.skillId = e ? parseInt(e.value.split(",")[0]) : 0;
      this.state.skillNameValue = e ? e.value?.split(",")[1] : "";
      this.state.skillNameEditShow = e;
      this.setState({});
    }
  };

  getLevelList = () => {
    let apiUrl = `${API.GET_LEVEL_MASTERDATA}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.levelList = res?.data?.map((level) => {
            return {
              value: level.id + "," + level.name,
              label: (
                <>
                  {/* <CommonIcon
                  className="properties-img-2"
                  fileName="levelIcon"
                />{" "}
                &nbsp; */}
                  <span>{level.name}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getSkillsList = () => {
    let apiUrl = `${API.GET_SKILLS_TYPE}`;
    // ?pageNumber=${this.state.currentPage}&pageSize=${this.state.perPage}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.skillsList = res?.data?.map((skill) => {
            return {
              value: skill.id + "," + skill.skillName,
              label: (
                <>
                  {/* <CommonIcon
                  className="properties-img-2"
                  fileName="skillIcon"
                />{" "}
                &nbsp; */}
                  <span>{skill.skillName}</span>
                </>
              ),
            };
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  backtoMainRole = () => {
    this.clearSearchFields1();
    this.setState({ isRequestLoader: true });
    this.getMainroleList();
    this.setState({
      isNewTemplate: false,
      isEditTemplate: false,
      isMainRole: true,
      selectedItem: [],
    });
  };

  handleCheckbox = (id) => {
    const { selectedItem } = this.state;
    if (selectedItem.length == 0) {
      selectedItem.push(id);
    } else {
      if (selectedItem && selectedItem.filter((i) => i == id).length == 1) {
        selectedItem.map((i, ind) =>
          i == id ? selectedItem.splice(ind, 1) : ""
        );
      } else {
        selectedItem.push(id);
      }
    }
    this.setState({});
  };

  // removeRole = () => {
  //   this.state.selectedItem.map((data) => {
  //     this.state.mainRolesList.map((item) => {
  //       if (data == item.id) {
  //         this.state.removeData = [...this.state.removeData, item];
  //       }
  //     });
  //   });
  //   this.state.removeData.map((item) => {
  //     item.isDeleted = true;
  //   });
  //   this.state.putNewData = {
  //     roleId: this.state.roleId,
  //     name: this.state.roleName,
  //     isPresent: true,
  //     skillJobs: [
  //       ...this.state.removeData,
  //       // {
  //       //   id: 1,
  //       //   jobId: this.state.jobId,
  //       //   job: this.state.JobNameValue,
  //       //   skillId: this.state.skillId,
  //       //   skill: this.state.skillNameValue,
  //       //   levelId: this.state.LevelId,
  //       //   level: this.state.LevelNameValue,
  //       //   proficiencyExpectedId: this.state.proficiencyId,
  //       //   proficiencyExpected: this.state.proficiencyExpectedValue,
  //       //   isDeleted: true
  //       // }
  //     ],
  //   };
  //   this.setState({});
  //   this.deleteMainRole();
  // };

  handleCheckboxTop = () => {
    //   this.state.currentEdit = [];
    //   this.state.skillsList.map((item) => {
    //     this.state.currentEdit = [...this.state.currentEdit , item.id];
    //   })
    let data = [];
    if (
      this.state.selectedItem?.length != this.state.mainRolesList?.length &&
      this.state.selectedItem?.length > 0 &&
      this.state.mainRolesList?.length > 0
    ) {
      this.state.mainRolesList?.map((r) => data.push(r.id));
    }
    if (
      this.state.selectedItem?.length == 0 &&
      this.state.mainRolesList?.length > 0
    ) {
      this.state.mainRolesList?.map((r) => data.push(r.id));
    }
    if (
      this.state.selectedItem?.length == this.state.mainRolesList?.length &&
      this.state.mainRolesList?.length > 0
    ) {
      data = [];
    }
    this.state.selectedItem = data;
    this.setState({});
  };

  sortTable1 = (name) => {
    let sortData = this.state.mainRolesList;
    if (sortData.length !== 0) {
      this.state.isRequestLoader = true;
      if (this.state.sortBy1 === name) {
        this.state.sortBy1 = name;
        if (this.state.order1 === "asc") {
          var ordernew = "desc";
          this.state.order1 = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order1 = ordernew;
        }
      } else {
        this.state.sortBy1 = name;
        this.state.order1 = "asc";
      }
      this.setState({ currentPage: 1 }, () => {
        this.getMainroleById()
      })
      // this.setState({}, () => {
      //   this.getMainroleById();
      // });
    }
  };

  sortTable = (name) => {
    let sortData = this.state.mainRolesList;
    if (sortData.length !== 0) {
      this.state.isRequestLoader = true;
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      // this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({ currentPageMr: 1 ,cloneIds: [] , cloneId: 0}, () => {
        this.getMainroleList()
      })
      // this.setState({}, () => {
      //   this.getMainroleList();
      // });
    }
  };

  openSearchFilterListView = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("searchMainroleScreen")
    );
    myOffcanvas.show();
    // this.state.isAdd = false;
    // this.state.isEdit = false;
    this.state.isSearch = false;
    this.state.isSearchRole = true;
    this.state.isFieldEmpty = false;
    this.state.jobGroupLimitExceed = false;
    this.state.jobLimitExceed = false;
    this.setState({});
    $("body").addClass("scrollhide");
  }

  openSearchFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addMainRoleScreen")
    );
    myOffcanvas.show();
    this.state.isAdd = false;
    this.state.isEdit = false;
    this.state.isSearch = true;
    this.state.isFieldEmpty = false;
    this.state.jobGroupLimitExceed = false;
    this.state.jobLimitExceed = false;
    this.setState({});
    $("body").addClass("scrollhide");
  };

  clearSearchFields = () => {
    this.state.isRequestLoader = true;
    this.state.searchData = {};
    this.state.jobSearch = "";
    this.state.jobGroupSearch = "";
    this.state.skillSearch = [];
    this.state.levelSearch = [];
    this.state.proficiencySearch = [];
    this.state.isFieldEmpty = false;
    this.setState({
      currentPage: 1,
      pageNewCount: !this.state.pageNewCount
    });
    $("body").removeClass("scrollhide");
    this.getMainroleById("search");
  };

  clearSearchFields1 = () => {
    this.state.isRequestLoader = true;
    this.state.searchData = {};
    this.state.jobSearch = "";
    this.state.jobGroupSearch = "";
    this.state.skillSearch = [];
    this.state.levelSearch = [];
    this.state.proficiencySearch = [];
    this.state.isFieldEmpty = false;
    this.setState({
      currentPage: 1,
      pageNewCount: !this.state.pageNewCount
    });
    $("body").removeClass("scrollhide");
    // this.getMainroleById("search");
  };

  find = (e) => {
    if (this.state.isMainRole == true && this.state.mainRolesList?.length > 0) {
      this.state.isRequestLoader = true;
      this.state.perPageMr = e.value;
      this.state.pagingListMainRole = e;
      // this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      const selectedPage = 1;
      this.state.currentPageMr = selectedPage;
      this.setState({ cloneIds: [], cloneId: 0 }, () => {
        this.getMainroleList();
      });
    }
    else if (this.state.isMainRole == false && this.state.mainRolesList?.length > 0) {
      this.state.isRequestLoader = true;
      this.state.perPage = e.value;
      this.state.paginListNewPage = e;
      // this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      const selectedPage = 1;
      this.state.currentPage = selectedPage;
      this.setState({}, () => {
        this.getMainroleById();
      });
    }
  };

  handlePageChange = (pageNumber) => {
    this.state.isRequestLoader = true;
    if (this.state.isMainRole == true) {
      this.state.currentPageMr = pageNumber;
      this.setState({ cloneIds: [], cloneId: 0 }, () => {
        this.getMainroleList()
      });
    } else if (this.state.isMainRole == false) {
      this.state.currentPage = pageNumber;
      this.setState({}, () => {
        this.getMainroleById()
      });
    }
  }

  searchMainRoleListView = () => {
    if (this.state.searchInput?.trim() !== "") {
      this.state.isFieldEmpty = false;
      this.state.isRequestLoader = true;
      this.setState({})
      $("#searchMainroleScreen").removeClass('show');
      $("body").removeClass("scrollhide")
      this.getMainroleList();
    }
    else {
      this.setState({ isFieldEmpty: true })
    }
  }

  clearSearchMainRoleListView = () => {
    this.setState({
      searchInput: "",
      isRequestLoader: true,
      isSearchRole: false
    }, () => this.getMainroleList())
    $("#searchMainroleScreen").removeClass('show');
    $("body").removeClass("scrollhide")
  }

  handleCheckboxMainRoles = (id) => {
    const { cloneIds } = this.state;
    if (cloneIds.length == 0) {
      cloneIds.push(id);
    } else {
      if (cloneIds && cloneIds.filter((i) => i == id).length == 1) {
        cloneIds.map((i, ind) => (i == id ? cloneIds.splice(ind, 1) : ""));
      } else {
        cloneIds.push(id);
      }
    }
    if (cloneIds.length > 0) {
      if (cloneIds.length == 1) {
        this.setState({
          cloneId: cloneIds[0]
        })
      } else {
        this.setState({
          cloneId: 0
        })
      }
    }
    else {
      this.setState({
        cloneId: 0
      })
    }
    this.setState({});
  };

  handleCheckboxTopmainRoles = () => {
    let data = [];
    if (
      this.state.cloneIds?.length !=
      this.state.mainRolesList?.length &&
      this.state.cloneIds?.length > 0 &&
      this.state.mainRolesList?.length > 0
    ) {
      this.state.mainRolesList?.map((r) =>
        data.push(r.roleId)
      );
    }
    if (
      this.state.cloneIds?.length == 0 &&
      this.state.mainRolesList?.length > 0
    ) {
      this.state.mainRolesList?.map((r) =>
        data.push(r.roleId)
      );
    }
    if (
      this.state.cloneIds?.length ==
      this.state.mainRolesList?.length &&
      this.state.mainRolesList?.length > 0
    ) {
      data = [];
    }
    this.state.cloneIds = data;
    this.setState({ cloneId: 0 });
    this.setState({});
  };

  handleChangeClone = (e, item) => {
    if (this.state.cloneId == item.roleId) {
      this.setState({
        cloneId: 0
      });
    } else {
      this.setState({
        cloneId: item.roleId
      });
    }
  }

  cloneModalOpen = () => {
    $("#cloneRolesModal").addClass("show");
    $("body").removeClass("scrollhide")
  }

  cloneSuccess = () => {
    this.setState({
      currentPageMr: 1,
      cloneId: 0
    }, () => {
      this.getMainroleList();
    })
  }

  deleteMainRolesList = () => {
    this.state.isRequestLoader = true;
    // /${this.state.selectedItem}
    let apiUrl = `${API.GET_MAIN_ROLES}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: this.state.cloneIds,
    })
      .then((res) => {
        if (res.status === 200) {
          $("body").removeClass("scrollhide");
          toast.success("main roles removed successfully", {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
          this.setState({ cloneIds: [], cloneId: 0 }, () => { this.getMainroleList() });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.setState({ isRequestLoader: false })
        swal("Error!", "Something went wrong. Please try again.", "warning");
        $("body").removeClass("scrollhide");
        console.log(error);
      });
  }

  checkingMap = () => {
    let url = `${API.POST_VALIDATE_ROLES}`;
    this.setState({
      isRequestLoader: true
    })
    axios({
      method: "POST",
      url: url,
      data: this.state.cloneIds
    })
      .then((res) => {
        if (res.data?.length > 0 && res.data) {
          this.setState({
            mapping: true,
            mappingList: res.data,
            isRequestLoader: false
          }, () => { this.openRemoveScreenMain() })
        }
        else {
          this.setState({
            mapping: false,
            isRequestLoader: false
          }, () => { this.openRemoveScreenMain() })
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        this.state.isRequestLoaderFailed = true;
        this.state.isRequestLoader = false;
        console.log(error);
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  }

  render() {
    const {
      isMobile,
      isNewTemplate,
      isRequestFailed,
      isRequestLoader,
      isEditTemplate,
      isAdd,
      isEdit,
      isMainRole,
      isSkillEmpty,
      isJobEmpty,
      isJobGroupEmpty,
      isProficiencyEmpty,
      isLevelEmpty,
      selectedItem,
      mainRolesList,
      isSmallMobile,
      iswebMobile,
      pageCount,
      pagingListMainRole,
      paginglist,
      isRadioMobile,
      sortBy,
      sortBy1,
      order1,
      isSearch,
      order,
    } = this.state;
    const { menuToggle } = this.props;
    return (
      <>
        <Toaster />
        {$("#addMainRoleScreen").hasClass("show") ||
          $("#editMainRoleScreen").hasClass("show") ||
          $("#searchSkillScreen").hasClass("show") ||
          $("#searchMainroleScreen").hasClass("show")
          ? (
            <div className="viewbar-overlay"></div>
          ) : (
            <></>
          )}
        <div
          className={`${isMobile
            ? "main-body-mobile"
            : menuToggle
              ? "menu-main-body"
              : "main-body"
            } `}
        >
          <LoaderVisible isLoader={isRequestLoader} />
          {/* <LoaderFailed isLoader={isRequestFailed} /> */}

          <div className="w-100 head-fixed-company">
            {isMobile == true ? (
              <>
                <div className="d-flex mobile-head border-bottom w-100 pr-10">
                  {isMainRole && (
                    <>
                      <div className="col-6 mobile-title">Main roles</div>
                      <div className="text-align-end border-none display d-flex align-items-center justify-content-end mt-3px col-6">
                        <span className="cursor-pointer d-flex align-items-center">
                          {this.state.cloneIds?.length !== 0 &&
                            <label className="d-flex me-2 pe-2 displaybutton1 cursor-pointer  align-items-center" nClick={() => this.checkingMap()}>
                              <CommonIcon fileName="RemoveIcon" />
                              <span className="text-14-bold1">Remove</span>
                            </label>}
                          {this.state.cloneId > 0 ?
                            <label className="d-flex me-2 pe-2 displaybutton2 cursor-pointer  align-items-center" onClick={() => this.cloneModalOpen()}>
                              <CommonIcon fileName="addIcon" />
                              <span className="text-14-bold1">Clone</span>
                            </label> : ""}
                          <span className="text-20-bold cursor-pointer text-16-red" onClick={() => this.openSearchFilterListView()}>
                            <CommonIcon fileName="filterIcon" />
                          </span>
                        </span>
                      </div>
                    </>
                  )}
                  {isNewTemplate && (
                    <div className="col-12 mobile-title">
                      New template - {this.state.roleName}
                    </div>
                  )}
                  {isEditTemplate && (
                    <div className="col-12 mobile-title">
                      Edit template - {this.state.roleName}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={`${isMainRole ? "" : "title"}`} >
                {isMainRole && (
                  <>
                    <div className={` ${menuToggle ? "width-100" : "width-filter"} px-4 position-relative border-bottom row `}>
                      <div className="col-6 border-none title">
                        <CommonIcon fileName="supportingMaxIcon" /><span className="pl-10 head-span">Main roles</span></div>
                      {/* <div className="filter-icon cursor-pointer text-align-end" onClick={this.openSearchFilter}>
           <CommonIcon fileName="filterIcon" />
        </div> */}
                      <div className="text-align-end title border-none display d-flex align-items-center justify-content-end mt-3px col-6">

                        <span className="cursor-pointer d-flex">
                          {this.state.cloneIds?.length !== 0 &&
                            <label className="d-flex me-2 pe-2 displaybutton1 cursor-pointer  align-items-center" onClick={() => this.checkingMap()}>
                              <CommonIcon fileName="RemoveIcon" />
                              <span className="text-14-bold1">Remove</span>
                            </label>}
                          {this.state.cloneId > 0 ?
                            <label className="d-flex me-2 pe-2 displaybutton2 cursor-pointer  align-items-center" onClick={() => this.cloneModalOpen()}>
                              <CommonIcon fileName="addIcon" />
                              <span className="text-14-bold1">Clone</span>
                            </label> : ""}
                          <span className="text-20-bold pr-30 cursor-pointer text-16-red" onClick={() => this.openSearchFilterListView()}>
                            <CommonIcon fileName="filterIcon" />
                          </span>
                        </span>
                      </div>
                    </div>
                  </>

                )}
                {isNewTemplate && (
                  <>
                    <label className="template-img">
                      <CommonIcon fileName="template" />
                    </label>
                    <span className="pl-10 head-span">
                      New template - {this.state.roleName}
                    </span>
                  </>
                )}
                {isEditTemplate && (
                  <>
                    <label className="template-img">
                      <CommonIcon fileName="template" />
                    </label>
                    <span className="pl-10 head-span">
                      Edit template - {this.state.roleName}
                    </span>
                  </>
                )}
              </div>
            )}
            {(isNewTemplate || isEditTemplate) && (
              <>
                <div
                  className={`${isMobile ? "" : ""
                    } position-relative border-bottom`}
                >
                  <div
                    className={`d-flex justify-content-start pl-10 ${isMobile ? "pr-0" : ""
                      } `}
                  >
                    {(isNewTemplate || isEditTemplate) && (
                      <button
                        className={`displaybutton ${isRadioMobile ? "pr-5" : ""
                          } ${isSmallMobile ? "pl-5" : ""}`}
                        onClick={() => this.openAddMainRole()}
                      >
                        <CommonIcon fileName="addIcon" />
                        <span className={`subhead-span p-2`}>Add</span>
                      </button>
                    )}
                    {selectedItem.length == 1 && (
                      <button
                        className={`displaybutton ${isRadioMobile ? "pr-5" : ""
                          }  ${isSmallMobile ? "pl-5" : ""}`}
                        onClick={() => this.openMainroleEdit(false, NaN)}
                      >
                        <CommonIcon fileName="EditIcon" />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    )}
                    {selectedItem.length > 0 && (
                      <button
                        className={`displaybutton ${isRadioMobile ? "pr-5" : ""
                          }  ${isSmallMobile ? "pl-5" : ""}`}
                        // data-bs-toggle="modal"
                        // data-bs-target="#CancelCourseScreen"
                        onClick={this.openRemoveScreen}
                      >
                        <CommonIcon fileName="RemoveIcon" />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    )}
                    {(isNewTemplate || isEditTemplate) && (
                      <>
                        <div
                          className={`position-absolute  end-0 ${isMobile
                            ? ""
                            : menuToggle
                              ? "ml-role-updated"
                              : "ml-role"
                            }`}
                        >
                          <button
                            className="displaybutton"
                            onClick={this.openSearchFilter}
                          >
                            <span>
                              <CommonIcon fileName="filterIcon" />
                            </span>
                          </button>

                          <button
                            className="displaybutton"
                            onClick={this.backtoMainRole}
                          >
                            <span>
                              <CommonIcon fileName="back" />
                            </span>
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className={`${isMobile
              ? isNewTemplate || isEditTemplate
                ? "favorite-mobile-table1"
                : "table1-mobile-nodata "
              : isNewTemplate || isEditTemplate
                ? "favorite-table1"
                : "table2-nodata"
              } table-responsive w-100`}
          >
            <div className={`table-fixed-header ${isMainRole ? (isMobile ? "table-scroll-xy-mobile top-105px" : menuToggle ? "table-scroll-xy-menutoggle mt-minius8" : "table-scroll-xy mt-minius8") : (isMobile ? "table-scroll-xy-mobile top-150px" : menuToggle ? "table-scroll-xy-menutoggle top-upcoming-training mt-minius8" : "table-scroll-xy top-upcoming-training mt-minius8")} table-list-view-bottom`} >
              {/* <div className={`${isMobile ? "table1-mobile-nodata " : "table1-nodata"} table-responsive w-100`}> */}
              {/* { isMainRole && <> */}
              <table
                className={`table text-start fileListTable2 fileListTable2roles table-borderless table-hover ${isMobile ? "" : ""
                  } table-responsive`}
              >
                <thead>
                  <tr>
                    {(isEditTemplate || isNewTemplate) && (
                      <>
                        <td>
                          <input
                            type="checkbox"
                            name="request"
                            checked={
                              selectedItem?.length > 0 &&
                                selectedItem?.length == mainRolesList?.length
                                ? true
                                : false
                            }
                            onClick={() => this.handleCheckboxTop()}
                          />
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable1("jobGroup")}
                        >
                          <span>Job group</span>
                          {sortBy1 === "jobGroup" && (
                            <CommonIcon
                              fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable1("jobName")}
                        >
                          <span>Job</span>
                          {sortBy1 === "jobName" && (
                            <CommonIcon
                              fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable1("skill")}
                        >
                          <span>Skills</span>
                          {sortBy1 === "skill" && (
                            <CommonIcon
                              fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable1("level")}
                        >
                          <span>Level</span>
                          {sortBy1 === "level" && (
                            <CommonIcon
                              fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable1("proficiencyExpected")}
                        >
                          <span>Proficiency expected</span>
                          {sortBy1 === "proficiencyExpected" && (
                            <CommonIcon
                              fileName={order1 === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                      </>
                    )}
                    {isMainRole && (
                      <>
                        <td>
                          <input
                            type="checkbox"
                            name="request"
                            checked={
                              this.state.cloneIds?.length > 0 &&
                                this.state.cloneIds?.length == this.state.mainRolesList?.length
                                ? true
                                : false
                            }
                            onClick={() => this.handleCheckboxTopmainRoles()}
                          />
                        </td>
                        <td
                          className="cursor-pointer pl-20"
                          onClick={() => this.sortTable("name")}
                        >
                          <span className="pl-20">Roles</span>
                          {sortBy === "name" && (
                            <CommonIcon
                              fileName={order === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                        <td></td>
                        <td className="cursor-pointer ">
                          <span className="">Template</span>
                        </td>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {mainRolesList?.length !== 0 ? (
                    mainRolesList?.map((item, index) => (
                      <tr key={index} className="background-color-table">
                        {isMainRole && (
                          <>
                            <td className="radio-td-width">
                              <input
                                type="checkbox"
                                name="request"
                                // checked={
                                //   this.state.cloneId == item.roleId
                                //     ? true
                                //     : false
                                // }
                                checked={
                                  this.state.cloneIds?.filter(
                                    (r) => r == item.roleId
                                  )?.length > 0
                                    ? true
                                    : false
                                }
                                onClick={(e) => this.handleCheckboxMainRoles(item.roleId)}
                              // onClick={(e) => this.handleChangeClone(e, item)}
                              />
                            </td>
                            <td className="pl-20">
                              <span className="tablefilename pl-20 cursor-pointer text-decoration-none">
                                {item.name}
                              </span>
                            </td>
                            <td></td>
                            <td>
                              <span
                                className={` ${item.isPresent == true
                                  ? "red-color"
                                  : "green-color"
                                  } tablefilename   cursor-pointer `}
                                onClick={() =>
                                  this.chooseTemplates(
                                    item.isPresent,
                                    item.roleId,
                                    item.name
                                  )
                                }
                              >
                                {item.isPresent == true ? "Edit" : "New"}
                              </span>
                            </td>
                          </>
                        )}
                        {(isEditTemplate || isNewTemplate) && (
                          <>
                            <td>
                              <input
                                type="checkbox"
                                name="request"
                                className="checkboxes t-input"
                                checked={
                                  selectedItem?.filter((r) => r == item.id)
                                    ?.length > 0
                                    ? true
                                    : false
                                }
                                onClick={() => this.handleCheckbox(item.id)}
                              />
                            </td>
                            <td className="min-width-25 pl-20">
                              <span className="tablefilename cursor-pointer text-decoration-none">
                                {item.jobGroup && item.jobGroup}
                              </span>
                            </td>
                            <td className="min-width-25 pl-20">
                              <span className="tablefilename cursor-pointer font-wei-600" onClick={() => this.openMainroleEdit(true, item.id)}>
                                {item.jobName}
                              </span>
                            </td>
                            <td className="min-width-25 pl-20">
                              <span className="tablefilename cursor-pointer text-decoration-none">
                                {item.skill}
                              </span>
                            </td>
                            <td className="min-width-25 pl-20">
                              <span className="tablefilename cursor-pointer text-decoration-none">
                                {item.level}
                              </span>
                            </td>
                            <td className="pl-20">
                              <span className="tablefilename cursor-pointer text-decoration-none">
                                {item.proficiencyExpected}
                              </span>
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={isMainRole ? 5 : 7} className="table-nodata text-center center-align">
                        {isNewTemplate == false && "No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* </>} */}
          </div>

          {/* Add offcanvas */}
          <div
            className={`offcanvas offcanvas-end offcanvasStyle ${this.state.isView ? "audit-offcanvas" : ''}`}
            tabIndex={-1}
            data-bs-scroll="false"
            data-bs-backdrop="false"
            id="addMainRoleScreen"
            aria-labelledby="offcanvasScrollingLabel"
          >
            <div
              className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"
                }`}
            >
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                {this.state.isView && "Main roles"}{isEdit && !this.state.isView && "Edit main roles"} {isAdd && "New main roles"}
                {isSearch && "Search"}
              </h6>
              <button
                className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""
                  }`}
                // id="closeButton"
                data-bs-dismiss="offcanvas"
                onClick={() => {
                  (isAdd || isEdit) && this.closeProperties();
                  $("body").removeClass("scrollhide");
                }}
              >
                <CommonIcon fileName="CrossIcon" />
              </button>
              <button
                className="display-none"
                id="closeButton"
                data-bs-dismiss="offcanvas"
              >
              </button>
            </div>
            {
              this.state.isView && <div style={{ marginLeft: "20px" }}><button
                className={`displaybutton ${isRadioMobile ? "pr-5" : "p-0"
                  }  ${isSmallMobile ? "pl-5" : ""}`}
                onClick={() => this.openMainroleEdit(false, this.state.mainRoleId)}
              >
                <CommonIcon fileName="EditIcon" />
                <span className={`subhead-span p-2`}>Edit</span>
              </button></div>
            }
            <div className="offcanvas-body px-4 pt-0">
              <div className="row">
                <div
                  className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
                >
                  <div className="form-group">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                        <label
                          className={`label-text  ${isMobile
                            ? "d-flex pt-2 mb-2-ledger"
                            : "d-flex mb-2-ledger mb-1"
                            }`}
                        >
                          <CommonIcon
                            className="img-width-15"
                            fileName="courseMaster"
                          />
                          <span className="pl-5 properties-search-span">
                            Job group
                          </span>      {
                            isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                          }
                        </label>
                        <input
                          type="text"
                          className={`form-control form-text-box my-input-class input-height ${isJobGroupEmpty || this.state.jobGroupLimitExceed && "border-red"
                            } `}
                          style={{
                            "border-radius": "0",
                            borderColor: this.state.isJobGroupEmpty || this.state.jobGroupLimitExceed ? "#d12232" : "",
                          }}
                          disabled={this.state.isView}
                          placeholder=""
                          value={isSearch ? this.state.jobGroupSearch : this.state.JobGroupValue}
                          onChange={(e) => this.onchangeJobGroup(e)}
                          required
                        />
                        {this.state.jobGroupLimitExceed === true ? (
                          <span className="spanErrMsg">Value must be less than 250 characters</span>
                        ) : (<></>)}
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                        <label
                          className={`label-text  ${isMobile
                            ? "d-flex pt-2 mb-2-ledger"
                            : "d-flex mb-2-ledger mb-1"
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="jobicon"
                          />
                          <span className="pl-5 properties-search-span">
                            Job
                          </span>
                          {
                            isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                          }
                        </label>

                        <input
                          type="text"
                          className={`form-control form-text-box my-input-class input-height ${isJobEmpty || this.state.jobLimitExceed && "border-red"
                            } `}
                          disabled={this.state.isView}
                          style={{
                            "border-radius": "0",
                            borderColor: this.state.isJobEmpty || this.state.jobLimitExceed ? "#d12232" : "",
                          }}
                          placeholder=""
                          value={isSearch ? this.state.jobSearch : this.state.JobNameValue}
                          onChange={(e) => this.onchangeJob(e)}
                          required
                        />
                        {this.state.jobLimitExceed === true ? (
                          <span className="spanErrMsg">Value must be less than 250 characters</span>
                        ) : (<></>)}
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                        <label
                          className={`label-text  ${isMobile
                            ? "d-flex pt-2 mb-2-ledger"
                            : "d-flex mb-2-ledger mb-1"
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="skillIcon"
                          />
                          <span className="pl-5 properties-search-span">
                            Skills
                          </span>
                          {
                            isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                          }

                        </label>
                        <Select
                          className={` text-12-normal-select my-input-class  ${isSkillEmpty && "border-red"
                            }  `}
                          classNamePrefix="assigngroups"
                          value={isSearch ? this.state.skillSearch : this.state.skillNameEditShow}
                          options={this.state.skillsList}
                          defaultValue={"Select"}
                          placeholder="Please select an option"
                          styles={styles}
                          isClearable={true}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isMulti={false}
                          isSearchable={true}
                          onChange={this.onchangeSkill}
                          isDisabled={this.state.isView}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                        <label
                          className={`label-text  ${isMobile
                            ? "d-flex pt-2 mb-2-ledger"
                            : "d-flex mb-2-ledger mb-1"
                            }`}
                        >
                          <CommonIcon
                            className="properties-img-2"
                            fileName="levelIcon"
                          />
                          <span className="pl-5 properties-search-span"> Level </span>
                          {
                            isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                          }
                        </label>
                        <Select
                          className={` text-12-normal-select my-input-class  ${isLevelEmpty && "border-red"
                            }  `}
                          classNamePrefix="assigngroups"
                          value={isSearch ? this.state.levelSearch : this.state.levelNameEditShow}
                          options={this.state.levelList}
                          defaultValue={"Select"}
                          placeholder="Please select an option"
                          styles={styles}
                          isClearable={true}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isMulti={false}
                          isSearchable={true}
                          onChange={this.onchangeLevel}
                          isDisabled={this.state.isView}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mb-2">
                        <label
                          className={`label-text  ${isMobile
                            ? "d-flex pt-2 mb-2-ledger"
                            : "d-flex mb-2-ledger mb-1"
                            }`}
                        >
                          <CommonIcon
                            className="img-width-15"
                            fileName="proficiencyExpected"
                          />
                          <span className="pl-5 properties-search-span">
                            Proficiency expected
                          </span>      {
                            isSearch ? <></> : <span className="MuiFormHelperText-contained">*</span>
                          }
                        </label>
                        <Select
                          className={` text-12-normal-select my-input-class  ${isProficiencyEmpty && "border-red"
                            }  `}
                          classNamePrefix="assigngroups"
                          value={isSearch ? this.state.proficiencySearch : this.state.proficiencyNameEditShow}
                          options={this.state.proficiencyList}
                          defaultValue={"Select"}
                          placeholder="Please select an option"
                          styles={styles}
                          isClearable={true}
                          isMulti={false}
                          menuPosition="fixed"
                          menuPlacement="auto"
                          isSearchable={true}
                          onChange={this.onchangeProficiecy}
                          isDisabled={this.state.isView}
                        />
                      </div>
                      <div className="col-12 mt-2 mb-2">
                        {this.state.isFieldEmpty && (
                          <span className="send-rework-label">
                            Atleast one field is required
                          </span>
                        )}
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
              {/* {(isSkillEmpty || isJobEmpty || isLevelEmpty || isProficiencyEmpty) ? (
                      <span className="send-rework-label">This field is required</span>
                    ) : (<></>)} */}
              <div className="col-12 col-sm-12 mb-1"> {/* col-md-6 col-lg-6 */}
                {!isSearch && !this.state.isView && (
                  <button
                    className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                      } p-2`}
                    aria-label="Close"
                    onClick={() => this.submitNewTemplate()}
                  >
                    {/* <img src={ButtonSubmitIcon} className="modal-img"></img> */}
                    <CommonIcon
                      fileName="ButtonSubmitIcon"
                      className="modal-img"
                    />
                    <span className="model-label pl-10">{isEdit ? "Update" : "Submit"}</span>
                  </button>
                )}
                {isSearch && (
                  <>
                    <div className="d-flex mb-1">
                      <button
                        data-bs-dismiss="offcanvas"
                        className="btn rejectbutton"
                        onClick={() => this.clearSearchFields()}
                      >
                        <CommonIcon
                          className="button-img"
                          fileName="ButtonRejectApprovalIcon"
                        />
                        <span className="px-1">Clear</span>
                      </button>
                      {/* <button className="btn approvebutton mx-2" onClick={() => this.searchMainRoleList()}><CommonIcon className="button-img" fileName="searchIcon" /><span className="pl-10">Search</span></button> */}
                      <button
                        //  data-bs-dismiss= {(!this.state.isFieldEmpty) && "offcanvas"}
                        className={`btn approvebutton d-flex gap-1 mx-2`}
                        onClick={() => this.searchMainRoleList()}
                      >
                        <span>
                          <CommonIcon fileName="searchableIcon" />
                        </span>
                        <span className="model-label pl-vendor3 pl-2">
                          Search
                        </span>
                      </button>
                    </div>
                  </>
                )}
                {
                  (this.state.isView || this.state.isEdit) && this.state.auditLog?.length > 0 && <div>
                    <div className="">
                      <h6 className="modal-title">Audit log</h6>
                    </div>
                    <div className="audit-table-wrapper audit-scroll-css">
                      <table className="px-3 audit-table w-100">
                        <thead>
                          <tr className="border-bottom">
                            <th className="p-rem">
                              Action
                            </th>
                            <th className="p-rem">
                              Action By
                            </th>
                            <th className="p-rem wid-45">
                              Description
                            </th>
                            <th className="p-rem">
                              Date
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            this.state.auditLog?.map((x, i) => (
                              <tr className="border-bottom" key={i}>
                                <td className="p-rem" key={`${i}-action`}>{x.action ? x.action : "-"}</td>
                                <td className="p-rem" key={`${i}-actionby`}>{x.actionBy ? x.actionBy : "-"}</td>
                                <td className="p-rem" key={`${i}-desc`}>
                                  {x.description ? x.description : "-"}
                                </td>
                                <td className="p-rem" key={`${i}-created`}>
                                  {x.createdTime ? moment.utc(x.createdTime).local().format("DD-MMM-YYYY, hh:mm A") : "-"}
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>

          {/* Edit offcanvas */}
        </div>

        {/* Main role List View Search */}
        <div className="offcanvas offcanvas-end offcanvasStyle" tabIndex={-1} data-bs-scroll="false" data-bs-backdrop="false" id="searchMainroleScreen" aria-labelledby="offcanvasScrollingLabel">
          <div className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">Search</h6>
            <button className={`text-reset offcavasclose buttonstyle background-white ${isMobile ? "pr-0" : ""}`} data-bs-dismiss="offcanvas" onClick={() => { this.setState({ isSearchRole: false }) }}>
              <CommonIcon fileName="CrossIcon" />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div className="row">
              <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}>
                <div className="form-group">
                  <label className={`label-text  ${isMobile ? "d-flex pt-2 mb-2-ledger" : "d-flex mb-2-ledger mb-1"}`}>
                    <CommonIcon fileName="supportingIcon" />
                    <span className="pl-10 properties-search-span">Role</span>
                  </label>
                  <input className={` form-control border-radius mt-2 font-size-12`}
                    onChange={(e) => {
                      this.setState({ searchInput: e.target.value })
                    }}
                    style={{ borderColor: this.state.isFieldEmpty ? "#d12232" : "" }}
                    value={this.state.searchInput} />
                  {this.state.isFieldEmpty ? (
                    <span className="send-rework-label">This field is required</span>
                  ) : (<></>)}
                </div>
              </div>
            </div>
            <div className="d-flex col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              {/* <button className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"} p-2`} onClick={() => {this.state.isSearch ? this.searchLevel() : this.addLevelList()}}>
                  <CommonIcon fileName="ButtonSubmitIcon" /><span className="model-label pl-10" >{this.state.isSearch ? "Search" : "Submit"}</span>
                </button> */}
              <button className="btn rejectbutton" onClick={() => this.clearSearchMainRoleListView()} >
                <CommonIcon className="button-img" fileName="ButtonRejectApprovalIcon" />
                <span className="px-1">Clear</span> </button>
              <button
                className={`btn approvebutton d-flex gap-1 mx-2`}
                onClick={() => { this.searchMainRoleListView() }}>
                <span><CommonIcon fileName="searchableIcon" /></span>
                <span className="model-label pl-vendor3 pl-2">Search</span>
              </button>
            </div>
          </div>
        </div>

        {/* Modal - Warning */}
        <WarningComponent
          message={this.state.selectedItem?.length > 1 ? "Are you sure you want to remove these main roles ?" : "Are you sure you want to remove this main role ?"}
          isMobile={this.state.isMobile}
          onYesClick={() => this.deleteMainRole()}
        />
        <WarningComponent
          id="deleteMainRoleWarning"
          message={this.state.mapping ? (this.state.mappingList?.length > 1 ? "The following roles are tagged to employees" : "The following role is tagged to employee") : (this.state.cloneIds?.length > 1 ? "Are you sure you want to remove these main roles ?" : "Are you sure you want to remove this main role ?")}
          isMobile={this.state.isMobile}
          onYesClick={() => this.deleteMainRolesList()}
          type={this.state.mapping ? (this.state.mappingList?.length > 1 ? "Main Roles" : "Main Role") : ""}
          mappingData={this.state.mapping ? this.state.mappingList : []}
        />

        {/* Pagination */}
        {/* <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={pageCount}
        /> */}
        {
          (this.state.isMainRole ? (this.state.pageCountMr > 0) : (this.state.pageCount > 0)) && <>

            <div
              className={`${isMobile ? "common-mobilesubmenu mobile-pagination"
                : menuToggle ? "common-submenu sidemenu-pagination" : "common-submenu web-pagination"} pb-2 pt-2`}>

              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div id="perPage" className={`${iswebMobile ? "mobilePageSelect" : "webpageSelect"}`}>
                        <Select
                          options={paginglist}
                          // defaultValue={this.state.paginglistDefault}
                          value={this.state.isMainRole ? this.state.pagingListMainRole : this.state.paginListNewPage}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td width="92%" className="text-end p-3">
                      {isMobile ?
                        <Pagination
                          prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                          nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item page-width-mobile`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={e => this.handlePageChange(e)}
                          activePage={this.state.isMainRole ? this.state.currentPageMr : this.state.currentPage}
                          totalItemsCount={this.state.isMainRole ? this.state.pageCountMr : this.state.pageCount}
                          itemsCountPerPage={this.state.isMainRole ? this.state.perPageMr : this.state.perPage}
                        /> :
                        <Pagination
                          prevPageText={<><CommonIcon fileName="LeftArrowIcon" /> </>}
                          nextPageText={<><CommonIcon fileName="RightArrowIcon" /></>}
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item page-width`}
                          linkClass="page-link"
                          pageRangeDisplayed={4}
                          onChange={e => this.handlePageChange(e)}
                          activePage={this.state.isMainRole ? this.state.currentPageMr : this.state.currentPage}
                          totalItemsCount={this.state.isMainRole ? this.state.pageCountMr : this.state.pageCount}
                          itemsCountPerPage={this.state.isMainRole ? this.state.perPageMr : this.state.perPage}
                        />}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        }
        <CommonCloneModal
          isMobile={this.state.isMobile}
          roleId={this.state.cloneId}
          cloneSuccess={() => this.cloneSuccess()}
          isCourse={false}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainRoles)
);
